import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./LatestBlogsSection.css"; // Import the custom CSS file

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const formatBlogDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const renderBlogCard = (blog) => (
  <div key={blog.id} className="blog-card" onClick={() => window.location.href = `/news/${blog.id}`}>
    <img 
      src={blog.thumbnail ? `${API_URL}${blog.thumbnail}` : 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'} 
      alt={blog.title} 
      className="blog-card-image"
    />
    <div className="blog-card-content">
      <div className="blog-date">{formatBlogDate(blog.created_at)}</div>
      <div className="blog-title">{blog.title}</div>
      <Link to={`/news/${blog.id}`} className="blog-link">
        Continue Reading →
      </Link>
    </div>
  </div>
);

const LatestBlogsSection = ({ count = 3 }) => {
  const [latestBlogs, setLatestBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchLatestBlogs();
    // eslint-disable-next-line
  }, [count]);

  const fetchLatestBlogs = async () => {
    try {
      const response = await fetch(`${API_URL}/api/blogs/latest/?count=${count}`);
      if (response.ok) {
        const data = await response.json();
        setLatestBlogs(data);
      } else {
        setError('Failed to fetch blogs');
      }
    } catch (err) {
      setError('Network error while fetching blogs');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="blogs-container">
      <div className="blogs-wrapper">
        <div className="blogs-heading">
          Our Blogs
        </div>
        {loading ? (
          <div className="blogs-loading">
            Loading blogs...
          </div>
        ) : error ? (
          <div className="blogs-error">
            {error}
          </div>
        ) : (
          <div className="blogs-grid">
            {latestBlogs.length > 0 ? (
              latestBlogs.map(renderBlogCard)
            ) : (
              <div className="blogs-empty">
                No blogs at the moment.
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LatestBlogsSection;